"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _index = require("../../../styles/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledTh = _styledComponents2.default.th.withConfig({
  displayName: "SortTableHeader__StyledTh",
  componentId: "svpgw4-0"
})([""]);

const StyledButton = _styledComponents2.default.button.withConfig({
  displayName: "SortTableHeader__StyledButton",
  componentId: "svpgw4-1"
})(["background:none;border:0;color:", ";cursor:pointer;font-size:inherit;font-weight:inherit;line-height:inherit;outline:none;padding:0;"], props => props.active ? _index.colors.accent : _index.colors.tableHeaderTextColor);

const StyledSpan = _styledComponents2.default.span.withConfig({
  displayName: "SortTableHeader__StyledSpan",
  componentId: "svpgw4-2"
})(["&:after{content:'", "';font-family:FontAwesome;margin-left:8px;}"], props => props.orderBy === "desc" ? "\f0d7" : "\f0d8");

const SortTableHeader = (_ref) => {
  let {
    children,
    orderBy = "desc",
    onClick = Function.prototype
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "orderBy", "onClick"]);

  return _react2.default.createElement(
    StyledTh,
    props,
    _react2.default.createElement(
      StyledButton,
      { active: props.active, onClick: () => onClick() },
      _react2.default.createElement(
        StyledSpan,
        { orderBy: orderBy },
        children
      )
    )
  );
};

SortTableHeader.propTypes = {
  children: _propTypes2.default.node,
  active: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  orderBy: _propTypes2.default.oneOf(["asc", "desc"])
};

exports.default = SortTableHeader;